import { getMonthName } from "./getMonthName";

export function getAdjustedDate(dateWhen, differenceDate) {
    const originalDate = new Date(dateWhen.year, parseInt(dateWhen.month) - 1, dateWhen.day);
    originalDate.setMonth(originalDate.getMonth() - differenceDate);
    const adjustedMonth = String(originalDate.getMonth() + 1).padStart(2, '0');
    const adjustedYear = originalDate.getFullYear();

    const day = originalDate.getDate(); 
    return {
      label: `${getMonthName(adjustedMonth)} ${adjustedYear}`,
      month: adjustedMonth,
      year: adjustedYear,
      day
    };
  }